/**
 * Root Route - Client Portal
 * Provides global layout wrapper for versicherten-facing app
 */
import { createRootRouteWithContext, Outlet, type ErrorComponentProps } from "@tanstack/react-router";
import { ConvexReactClient } from "convex/react";
import { ErrorFallback } from "@jourfx/ui";

interface RouterContext {
  convex: ConvexReactClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
  errorComponent: RouteErrorComponent,
});

function RootComponent() {
  return (
    <main id="main-content">
      <Outlet />
    </main>
  );
}

function NotFoundComponent() {
  return (
    <div className="min-h-screen client-gradient-bg flex items-center justify-center p-4">
      <div className="client-card p-8 max-w-md w-full text-center">
        <h1 className="text-4xl font-bold text-[var(--stone-800)] mb-4">404</h1>
        <p className="text-[var(--stone-600)] mb-6">
          Diese Seite wurde nicht gefunden.
        </p>
        <a
          href="/"
          className="inline-flex items-center justify-center px-6 py-3 rounded-xl font-semibold bg-[var(--sage-600)] text-white hover:bg-[var(--sage-700)] transition-colors"
        >
          Zurück zur Startseite
        </a>
      </div>
    </div>
  );
}

function RouteErrorComponent({ error }: ErrorComponentProps) {
  return <ErrorFallback error={error instanceof Error ? error : new Error(String(error))} />;
}
